import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthFacade } from '../../features/auth/facade/auth.facade';

export const onboardingGuard: CanActivateFn = (route, state) => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  if (!authFacade.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }

  const onboardingCompleted = typeof window !== 'undefined' && localStorage.getItem('onboardingCompleted') === 'true';
  if (onboardingCompleted) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
